<template>
  <div id="property-map">
    <mgl-map
      container="property-map"
      :access-token="accessToken"
      :map-style.sync="mapStyle"
      :center.sync="center"
      :zoom="zoom"
      @load="onMapLoaded"
    >
      <mgl-scale-control></mgl-scale-control>
      <mgl-navigation-control postion="top-right"></mgl-navigation-control>
      <mgl-fullscreen-control position="top-right"></mgl-fullscreen-control>
      <mgl-marker
        anchor="bottom"
        :offset="markerOffset"
        color="red"
        :coordinates="marker"
      >
      </mgl-marker>
    </mgl-map>
  </div>
</template>

<script>
import Mapbox from 'mapbox-gl';
import {
  MglMap,
  MglMarker,
  MglScaleControl,
  MglNavigationControl,
  MglFullscreenControl,
} from 'vue-mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'vue-mapbox/dist/vue-mapbox.css';

export default {
  name: 'PropertyMap',
  components: {
    MglMap,
    MglMarker,
    MglScaleControl,
    MglNavigationControl,
    MglFullscreenControl,
  },
  props: {
    coords: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      accessToken: process.env.MIX_MAPBOX_API_TOKEN,
      mapStyle: 'mapbox://styles/mapbox/satellite-streets-v10',
      zoom: 16,
      markerOffset: [0, 0],
      center: this.coords,
      marker: this.coords,
    };
  },
  created() {
    this.mapbox = Mapbox;
  },
  methods: {
    onMapLoaded(event) {
      this.map = event.map;
    },
  },
};
</script>

<style scoped>
#property-map {
  height: 400px;
}
</style>
